import React, { useState } from "react";
import { Input } from "reactstrap";

// Buscador con ícono y botón para limpiar. Misma API de siempre: onSearch(value).
const Search = ({ onSearch }) => {
    const [search, setSearch] = useState("");

    const onInputChange = value => {
        setSearch(value);
        onSearch(value);
    };

    return (
        <div className="dt-search">
            <i className="fas fa-search" />
            <Input
                bsSize="sm"
                type="text"
                placeholder="Buscar"
                value={search}
                onChange={e => onInputChange(e.target.value)}
            />
            {search ? (
                <button type="button" className="dt-search-clear" onClick={() => onInputChange("")} title="Limpiar">
                    <i className="fas fa-times" style={{ position: "static", transform: "none" }} />
                </button>
            ) : null}
        </div>
    );
};

export default Search;
